import { t } from 'i18next'
import TreeNode from 'primereact/treenode'
import React from 'react'
import { getModuleTypeIcon } from './ModulePlanHelper'

export const ModuleNodeTemplate = (node: TreeNode) => {
  if (!node.data) {
    return node.label
  }
  const type = node.data.id_apprenticeship_module_type
  let color = ''

  switch (type) {
    case 1:
      color = 'icon-blue '
      break
    case 2:
      color = 'icon-green '
      break
    case 4:
      color = 'icon-gold '
      break
    default:
      color = 'icon-dark-gray '
  }
  return (
    <div
      className={'inline-flex col-10 mt-0 mb-0 pt-0 pb-0'}
      style={{ borderTop: '1px solid #eee', borderBottom: '1px solid #eee' }}
    >
      <div className={'col-2 min-width-140'}>
        <span className={color + getModuleTypeIcon(type)} />
        <b className={'ml-2'}>{node.data.module_key}</b>
      </div>
      <span className={'col small-text'}>{node.data.description}</span>
      <div className={'col-4 p-0 m-0'}>
        <p className={' small-text secondary-text'}>
          {t<string>('grade_module.grade.schema.name')}:{' '}
          {t<string>(`grade_module.grade.schema.${node.data.id_grade_schema}`)}
        </p>
        {node.data.id_grade_schema !== 5 && (
          <p className={'  small-text secondary-text'}>
            {t<string>('grade_module.grade.rounding_type.name')}:{' '}
            {t<string>(
              `grade_module.grade.rounding_type.${node.data.id_rounding_type}`
            )}
          </p>
        )}
      </div>
    </div>
  )
}